export default {
  variations: [],
  isLoadedVariations: false,
  selectedTab: 'confirmed',
  loadedParticipants: [],
}
